import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom';
import { useModal } from '../../contexts/ModalContext';

export default function MeetingTeambuild({teamBuild}) {
    const { openQueryModal } = useModal();

    const settings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 2400,
        autoplaySpeed: 3500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
        prevArrow: (
            <button className="slick-arrow slick-prev">
                <img src='/image/longright-arrow.svg' alt="arrow"/>
            </button>
        ),
        nextArrow: (
            <button className="slick-arrow slick-next" >
                <img src='/image/longright-arrow.svg' alt="arrow"/>
            </button>
        ),

        responsive: [
            {
                breakpoint: 991,
                settings: { slidesToShow: 1, },
            },
            {
                breakpoint: 767,
                settings: { slidesToShow: 1, },
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 1, },
            },
        ],
    };

    return (
    <>
    <section className='meeting-teambuild'>
        <div className='meeting-left-card'>
            <img src={teamBuild?.leftImage} className='img-responsive' alt="team" />
            <div className='heading' dangerouslySetInnerHTML={{ __html: teamBuild?.leftTitle }} />
        </div>

        <div className='container'>
            <div className='row justify-content-end'>
                <div className='col-lg-5 col-md-6'>
                    <div className='meeting-teambuid-slider'>
                        <h4>{teamBuild?.subtitle}</h4>
                        
                        <Slider {...settings}>
                            {teamBuild?.slides?.map((item, index) => (
                                <div className='teambuid-slider-inner' key={index}>
                                <label className='heading'>{item.title}</label>
                                <img src={item.image} className='img-responsive' alt="team" />
                                <p>{item.desc}</p>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>

            </div>
        </div>
    </section>
 
    <div className='teambulid-buttn text-center'>
        <Link onClick={openQueryModal} className="default-btn color-btn">
            Request for Proposal
        </Link>
    </div>
    </>
    )
}